import React from 'react';
import {Link} from 'react-router-dom'

export default class Breadcumb extends React.Component {
    render(){
        return(
            <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link style={{color:'white'}}to='/'>Home</Link></li>
                    <li className="breadcrumb-item active" style={{color:'white'}} aria-current="page">{this.props.pageName}</li>
            </ol>
            </nav>
        )
    }
}